export default class RequestError extends Error {
  constructor(status) {
    super(`Request failed.  Please contact support with error code ${status}.`);
    this.status = status;
    this.name = 'RequestError';
  }

  get message() {
    return `Request failed.  Please contact support with error code ${this.status}`;
  }
}



// WEBPACK FOOTER //
// ./src/lib/errors/RequestError.js